<section class="page">
  <div class="page-header">
    <h1>Für wen ist der Termin?</h1>
    <p>Bitte geben Sie die Patientendaten und Kontaktdaten an.</p>
  </div>

  <app-error-banner [message]="errorMessage"></app-error-banner>

  <div class="form-layout">
    <form [formGroup]="form" class="form-card">
      <section class="section">
        <h2>Für wen ist der Termin?</h2>
        <div class="option-grid two-columns">
          <button
            mat-stroked-button
            type="button"
            class="option-button"
            [class.selected]="form.get('bookingFor')?.value === 'self'"
            (click)="form.get('bookingFor')?.setValue('self')"
          >
            Für mich selbst
          </button>
          <button
            mat-stroked-button
            type="button"
            class="option-button"
            [class.selected]="form.get('bookingFor')?.value === 'other'"
            (click)="form.get('bookingFor')?.setValue('other')"
          >
            Für eine andere Person
          </button>
        </div>
      </section>

      <section class="section">
        <h2>Patientendaten</h2>
        <div class="field-grid">
          <mat-form-field appearance="outline">
            <mat-label>Vorname</mat-label>
            <input matInput formControlName="firstName" />
            <mat-hint>Bitte nur das deutsche Alphabet verwenden (inkl. Ä, Ö, Ü und ß).</mat-hint>
            <mat-error *ngIf="form.get('firstName')?.hasError('germanName')">
              Nur Buchstaben, Leerzeichen und Bindestrich erlaubt.
            </mat-error>
            <mat-error *ngIf="form.get('firstName')?.hasError('required')">Pflichtfeld</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Nachname</mat-label>
            <input matInput formControlName="lastName" />
            <mat-hint>Bitte nur das deutsche Alphabet verwenden (inkl. Ä, Ö, Ü und ß).</mat-hint>
            <mat-error *ngIf="form.get('lastName')?.hasError('germanName')">
              Nur Buchstaben, Leerzeichen und Bindestrich erlaubt.
            </mat-error>
            <mat-error *ngIf="form.get('lastName')?.hasError('required')">Pflichtfeld</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Geburtsdatum</mat-label>
            <input matInput type="date" formControlName="birthDate" />
            <mat-error *ngIf="form.get('birthDate')?.hasError('required')">Pflichtfeld</mat-error>
          </mat-form-field>
        </div>
      </section>

      <section class="section">
        <h2>Kontaktdaten</h2>
        <div class="field-grid">
          <mat-form-field appearance="outline">
            <mat-label>Telefonnummer</mat-label>
            <input matInput formControlName="phone" inputmode="tel" />
            <mat-error *ngIf="form.get('phone')?.hasError('required')">Pflichtfeld</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>E-Mail</mat-label>
            <input matInput formControlName="email" type="email" />
            <mat-error *ngIf="form.get('email')?.hasError('required')">Pflichtfeld</mat-error>
            <mat-error *ngIf="form.get('email')?.hasError('email')">Ungültige E-Mail</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>E-Mail wiederholen</mat-label>
            <input matInput formControlName="emailRepeat" type="email" />
            <mat-error *ngIf="form.get('emailRepeat')?.hasError('required')">Pflichtfeld</mat-error>
            <mat-error *ngIf="emailMismatch">E-Mail-Adressen stimmen nicht überein.</mat-error>
          </mat-form-field>
        </div>
      </section>

      <section class="section">
        <h2>Einwilligungen</h2>
        <mat-checkbox formControlName="privacyAccepted">
          Ich stimme der Verarbeitung meiner Daten gemäß Datenschutz zu.
        </mat-checkbox>
        <div class="consent-error" *ngIf="form.get('privacyAccepted')?.touched && form.get('privacyAccepted')?.invalid">
          Bitte bestätigen Sie den Datenschutz.
        </div>
        <mat-checkbox formControlName="proxyAccepted" *ngIf="isOtherPerson">
          Ich habe die Zustimmung, den Termin im Namen des Patienten zu buchen.
        </mat-checkbox>
        <div class="consent-error" *ngIf="isOtherPerson && form.get('proxyAccepted')?.touched && !form.get('proxyAccepted')?.value">
          Bitte bestätigen Sie die Einwilligung zur Buchung für eine andere Person.
        </div>
      </section>

      <div class="action-bar">
        <button mat-stroked-button color="primary" type="button" (click)="back()">Zurück</button>
        <button mat-flat-button color="primary" type="button" [disabled]="isSubmitting" (click)="submit()">
          Weiter
        </button>
      </div>
    </form>

    <aside class="summary-pane">
      <app-appointment-summary-card
        [preselection]="flowState.snapshot.preselection"
        [day]="flowState.snapshot.selectedDay"
        [slot]="flowState.snapshot.selectedSlot"
      ></app-appointment-summary-card>
    </aside>
  </div>
</section>
